import React from 'react';

function NotFound() {
  return (
    <div className="not-found">
      <h1 className="display-1">404 Not Found</h1>
    </div>
  );
}

export default NotFound;
